
// NGRX
import { createFeatureSelector } from '@ngrx/store';
import { EntityState, EntityAdapter, createEntityAdapter, Update } from '@ngrx/entity';
// Actions
import { PartnerActions, PartnerActionTypes } from '../_actions/partner.actions';
// CRUD
import { QueryParamsModel } from '../../_base/crud';
// Models
import { PartnerModel } from '../_models/partner.model';

export interface PartnersState extends EntityState<PartnerModel> {
    listLoading: boolean;
    actionsloading: boolean;
    totalCount: number;
    lastQuery: QueryParamsModel;
    lastCreatedPartnerId: number;
    showInitWaitingMessage: boolean;
}

export const adapter: EntityAdapter<PartnerModel> = createEntityAdapter<PartnerModel>();

export const initialPartnersState: PartnersState = adapter.getInitialState({
    listLoading: false,
    actionsloading: false,
    totalCount: 0,
    lastQuery:  new QueryParamsModel({}),
    lastCreatedPartnerId: undefined,
    showInitWaitingMessage: true
});

export function PartnersReducer(state = initialPartnersState, action: PartnerActions): PartnersState {
    switch  (action.type) {
        case PartnerActionTypes.PartnersPageToggleLoading: return {
            ...state, listLoading: action.payload.isLoading, lastCreatedPartnerId: undefined
        };
        case PartnerActionTypes.PartnersActionToggleLoading: return {
            ...state, actionsloading: action.payload.isLoading
        };
        case PartnerActionTypes.PartnerOnServerCreated: return {
            ...state
        };
        // case PartnerActionTypes.PartnerCreated: return adapter.addOne(action.payload.Partner, {
        //      ...state, lastCreatedPartnerId: action.payload.Partner.id
        // });
        case PartnerActionTypes.PartnerUpdated: return adapter.updateOne(action.payload.partialPartner, state);
        case PartnerActionTypes.PartnersStatusUpdated: {
            const _partialPartners: Update<PartnerModel>[] = [];
            //for (let i = 0; i < action.payload.Partners.length; i++) {
                _partialPartners.push({
				    id: action.payload.partner,
				    changes: {
                        active: action.payload.status
                    }
			    });
            //}
            return adapter.updateMany(_partialPartners, state);
        }
        case PartnerActionTypes.OnePartnerDeleted: return adapter.removeOne(action.payload.id, state);
        case PartnerActionTypes.ManyPartnersDeleted: return adapter.removeMany(action.payload.ids, state);
        case PartnerActionTypes.PartnersPageCancelled: return {
            ...state, listLoading: false, lastQuery: new QueryParamsModel({})
        };
        case PartnerActionTypes.PartnersPageLoaded:
            return adapter.addMany(action.payload.partner, {
                ...initialPartnersState,
                totalCount: action.payload.totalCount,
                listLoading: false,
                lastQuery: action.payload.page,
                showInitWaitingMessage: false
            });
        default: return state;
    }
}

export const getPartnerState = createFeatureSelector<PartnerModel>('partner');

export const {
    selectAll,
    selectEntities,
    selectIds,
    selectTotal
} = adapter.getSelectors();
